export default "/images/5a7c2bc0b481067218ffa5eccb73f8d9.avif";